
import Vue from 'vue'
import App from './App'
import router from './router/index'
import 'default-passive-events'
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// 富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);

// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//引入公共样式
import './assets/css/reset.less'
import './assets/css/material-list.less'
import './assets/css/orderList.less'
import './icons/iconfont.css'

//引入vuex
import store from './store/index'

// 引入公共的js文件
import upload from './utils/public'
Vue.prototype.$utils = upload
import {getSettingConfig,dateFormat} from './utils/index'
Vue.prototype.getSettingConfig=getSettingConfig
Vue.prototype.dateFormat = dateFormat
import '@/icons'
// 引入api
import './utils/request'
// 适配
import './utils/rem.js'
import  './utils/aliplayercomponents-1.0.8.min'
import './utils/socket'
import htmlToPdf from './utils/pdf'
Vue.use(htmlToPdf)

// 传值
Vue.prototype.$Bus = new Vue();
import "babel-polyfill";
// 公用的组件
import pag from '@/pages/Pagination'
import videoList from '@/components/video/video'
import noContainer from './pages/blank'
Vue.use(pag).use(videoList).use(noContainer)  //引用自定义组件
Vue.component('zg-pag',pag) //初始化组件
Vue.component('course',videoList)
Vue.component('zg-404',noContainer)

// 获取input焦点
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

// 图片放大
import VuePhotoZoomPro from 'vue-photo-zoom-pro'
Vue.use(VuePhotoZoomPro)

import payBox from './components/payBox';
Vue.component('payBox',payBox)
// 视频播放
import 'vue-aliplay-player/lib/vue-aliplay-player.css'
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    pag,
    videoList,
    noContainer
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js